import React from "react";
import { Row, Col } from 'reactstrap';

const OfferCard = ({offer}) => (
  <div className="offer-card">
    {offer.image_url &&
      <img className="offer-image" src={offer.image_url} alt="Offer card"/>
    }
    <div className="offer-content">
      <Row className="offer-header justify-content-between">
        <Col>
          <span className="offer-type">Partner Survey</span>
        < /Col>
        <Col className="text-right">
          <span className="offer-compensation">{offer.estimated_earnings_msr} MSR</span>
        </Col>
      </Row>
      <div className="offer-title">{offer.title}</div>
      <div className="offer-description">{offer.description}</div>
      <div className="offer-estimated-time">
        {offer.estimated_minutes_to_complete} minutes to complete
      </div>
      <div className="offer-expiry">
        Expires in 2 days
      </div>
    </div>
  </div>
)

export default OfferCard;
